import React from 'react';
import CgvManager from '../Components/CgvManager/CgvManager';

const CgvManagerPage = () => {
    return (
        <div style={{
            minHeight: '100vh',
            background: '#f8f9fa',
            padding: '20px 0'
        }}>
            <CgvManager />
        </div>
    );
};

export default CgvManagerPage; 